Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

// This is a magic string replaced by rollup

const SDK_VERSION = "9.5.0" ;

exports.SDK_VERSION = SDK_VERSION;
//# sourceMappingURL=version.js.map
